module.exports = __webpack_public_path__ + "static/media/Ripple.8ca328c3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/Modal/Ripple.gif
// module id = 430
// module chunks = 2